(function () {
  function openJoyWidget() {
    if (typeof window.avadaJoyTrigger === "function") {
      window.avadaJoyTrigger();
      return true;
    }

    var joy = window.joyInstance || window.joy;
    if (joy && typeof joy.openWidget === "function") {
      joy.openWidget();
      return true;
    }

    var launcher = document.getElementById("Avada-Joy_FloatingButtonTrigger");
    if (launcher) {
      launcher.click();
      return true;
    }

    return false;
  }

  window.SherpaOpenJoy = function (event) {
    if (event) event.preventDefault();
    if (openJoyWidget()) return;

    var opened = false;
    var onReady = function () {
      if (opened) return;
      opened = openJoyWidget();
    };

    window.addEventListener("joy:ready", onReady, { once: true });
    window.setTimeout(function () {
      window.removeEventListener("joy:ready", onReady);
      if (!opened) openJoyWidget();
    }, 800);
  };
})();
